<template>
  <a :id="id" class="neon-anchor"></a>
</template>

<script lang="ts" src="./NeonAnchor.ts" />
